module.exports = __webpack_public_path__ + "img/s1v2t2.dbc8abd8.jpeg";